import { css } from 'lit';

import { transition, typography } from '../../styles';
import color from '../../utils/get-color-token';

function styles() {
	return css`
		:host {
			--m-text-color: ${color('color-text-primary')};
		}

		.m-text {
			${transition([{ property: 'color' }])};

			${typography()};

			display: inline-block;

			color: var(--m-text-color);
		}

		.-body-lg-bold {
			${typography('body-lg-bold')};
		}

		.-body-lg {
			${typography('body-lg')};
		}

		.-body-md-bold-underline {
			${typography('body-md-bold-underline')};
		}

		.-body-md-bold {
			${typography('body-md-bold')};
		}

		.-body-md-underline {
			${typography('body-md-underline')};
		}

		.-body-md {
			${typography('body-md')};
		}

		.-body-sm-bold-underline {
			${typography('body-sm-bold-underline')};
		}

		.-body-sm-bold {
			${typography('body-sm-bold')};
		}

		.-body-sm-underline {
			${typography('body-sm-underline')};
		}

		.-body-sm {
			${typography('body-sm')};
		}

		.-button-lg {
			${typography('button-lg')};
		}

		.-button-md {
			${typography('button-md')};
		}

		.-button-sm {
			${typography('button-sm')};
		}

		.-chips-md {
			${typography('chips-md')};
		}

		.-chips-sm {
			${typography('chips-sm')};
		}

		.-heading-lg-bold {
			${typography('heading-lg-bold')};
		}

		.-heading-lg {
			${typography('heading-lg')};
		}

		.-heading-md-bold {
			${typography('heading-md-bold')};
		}

		.-heading-md {
			${typography('heading-md')};
		}

		.-heading-sm-bold {
			${typography('heading-sm-bold')};
		}

		.-heading-sm {
			${typography('heading-sm')};
		}

		.-hero-lg-bold {
			${typography('hero-lg-bold')};
		}

		.-hero-lg {
			${typography('hero-lg')};
		}

		.-hero-md-bold {
			${typography('hero-md-bold')};
		}

		.-hero-md {
			${typography('hero-md')};
		}

		.-hero-sm-bold {
			${typography('hero-sm-bold')};
		}

		.-hero-sm {
			${typography('hero-sm')};
		}

		.-number-md {
			${typography('number-md')};
		}

		.-number-sm {
			${typography('number-sm')};
		}

		.-table-header-md {
			${typography('table-header-md')};
		}

		.-table-header-sm {
			${typography('table-header-sm')};
		}
	`;
}

export default styles;
